<script>
export default {
  name: "reset-password-modal",
  data: function() {
    return {
      email: "",
    };
  },
  methods: {
    async resetPassword() {
      this.$store.commit("toggleResetPasswordModal", false);
      var result = await this.$store.dispatch("getRequest", { controller: "login", method: `Reset`, parameters: { email: this.email } });

      if (result) {
        this.$store.commit("setMessage", { title: "Password Reset", type: "info", content: `Your password has been reset. Please check your emails.` });
      } else {
        this.$store.commit("setMessage", { title: "Unable to reset password", type: "error", content: `We were unable to reset your password - Please contact an administrator.` });
      }
    },
    onModalShown: function() {
      this.email = "";
    },
    onModalClose: function() {
      this.$store.commit("toggleResetPasswordModal", false);
    },
  },
  computed: {
    modalVisible: function() {
      return this.$store.state.resetPasswordShown;
    },
  },
};
</script>
<template>
  <div>
    <b-modal id="reset-password-modal" title="Reset Password" v-on:shown="onModalShown" v-on:hidden="onModalClose" :hide-footer="true" v-model="modalVisible">
      <div class="row">
        <div class="col-lg-12">
          <div style="padding:5px;">
            <input v-model="email" class="form-control mr-sm-2" type="text" placeholder="Email Address" aria-label="Email Address" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div style="padding:5px;">
            <button class="btn btn-light" style="width:100%" type="button" v-on:click="resetPassword">
              <span class="login-button-content">Reset<i class="far fa-envelope icon-right"></i></span>
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
